import React from "react"
import { ICON_CONSTANTS } from "../../../constants/ImageConstants.js"
import { Button } from "react-bootstrap"

/**
 * FloatingSelectArea Component
 *
 * Renders a floating area displaying selected area information and an action button.
 * Allows for a custom button section to be rendered instead of the default button.
 *
 * Props:
 * @param {string} totalArea - The total area to display.
 * @param {string} totalLandArea - The total land area to display.
 * @param {string} buttonlabel - The label for the button.
 * @param {function} handleClick - Callback for button click.
 * @param {boolean} withIcon - If true, displays an icon in the button.
 * @param {string} icon - URL for the button icon.
 * @param {string} labelIcon - URL for the icon next to the label.
 * @param {string} buttonColor - Color variant for the button.
 * @param {React.ReactNode} frontIcon - Element to display before the button label.
 * @param {string} label - Custom label text next to the total area.
 * @param {boolean} disableButton - If true, disables the button.
 * @param {boolean} showInfo - If true, displays additional info text.
 * @param {string} infoText - Additional information text.
 * @param {function|null} customButtonSection - Function returning a custom button section, this will override the default button, handleClick, and buttonlabel, withIcon, icon, disableButton, and buttonColor will be ignored if this is provided.
 *@param {string} labelFontSize - Font size for the label text.
 * @param {React.ReactNode} totalComponent - Custom component to display total area information, overrides totalArea, totalLandArea, and label if provided.
 *
 * @returns {JSX.Element} The rendered FloatingSelectArea component.
 */
export const FloatingSelectArea = ({
  totalArea,
  totalLandArea,
  buttonlabel,
  handleClick,
  withIcon,
  icon,
  labelIcon,
  buttonColor,
  frontIcon,
  label,
  disableButton = false,
  showInfo,
  infoText,
  customButtonSection = null,
  labelFontSize = "sm",
  totalComponent
}) => {

  const defaultButton = () => (
    <Button
      disabled={disableButton}
      onClick={handleClick}
      className={"d-flex align-items-center color-white ml-4"}
      variant={buttonColor ?? "success"}>
      {frontIcon && frontIcon}
      {buttonlabel}{" "}
      {withIcon && (
        <img src={icon ? icon : ICON_CONSTANTS.ARROW_RIGHT_WHITE} className={"ml-2"} />
      )}
    </Button>
  )
  return (
    <div className={`floating-select-area`}>
      <div className={"d-flex justify-content-between align-items-center"}>
        <div className={"d-flex align-items-center"}>
          <img src={labelIcon || ICON_CONSTANTS.MAP_WHITE} alt={""} className={"mr-2"} />
          { totalComponent ?
            totalComponent :
            <div className={`color-white d-flex text-lowercase font-size-${labelFontSize}`}>
              {totalArea} {label ? label : "lahan terpilih"}{" "}
              <span className={"font-weight-light ml-1"}>{totalLandArea}</span>
            </div>
          }
        </div>
        <div className={"d-flex align-items-center"}>
          {showInfo && infoText}
          {customButtonSection ? customButtonSection() : defaultButton()}
        </div>
      </div>
    </div>
  )
}
